import { render, staticRenderFns } from "./AddorEdit.vue?vue&type=template&id=de45fa40&scoped=true&"
import script from "./AddorEdit.vue?vue&type=script&lang=js&"
export * from "./AddorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de45fa40",
  null
  
)

export default component.exports